<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">

        <div class="title-wrapper mb-4">
            <div>
                <h1 class="title-default">
                    {{ isEditMode ? 'Editar Natureza de Operação' : 'Nova Natureza de Operação' }}
                </h1>
                <p class="welcome-message">
                    <button mat-icon-button type="button" (click)="cancelar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    Defina as configurações de identificação e tributação.
                </p>
            </div>
        </div>

        @if (isLoading) {
        <div class="natop-skeleton">
            <div class="skeleton-tabs">
                <div class="skeleton skeleton-tab"></div>
                <div class="skeleton skeleton-tab"></div>
                <div class="skeleton skeleton-tab"></div>
            </div>
            <div class="skeleton-card">
                <div class="skeleton skeleton-line skeleton-line--title"></div>
                <div class="skeleton-grid">
                    <div class="skeleton skeleton-field"></div>
                    <div class="skeleton skeleton-field"></div>
                    <div class="skeleton skeleton-field"></div>
                    <div class="skeleton skeleton-field"></div>
                    <div class="skeleton skeleton-field"></div>
                    <div class="skeleton skeleton-field"></div>
                </div>
            </div>
        </div>
        } @else {

        <!-- Abas -->
        <mat-tab-group class="main-tabs" appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true" [(selectedIndex)]="selectedTabIndex">

            <!-- Identificação -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">badge</mat-icon>
                    <span class="tab-label-text">Dados Gerais</span>
                </ng-template>
                <app-natureza-operacao-dados-gerais-tab
                    [form]="form"
                    [finalidades]="finalidades"
                    [regimes]="regimes"
                    [tiposOperacao]="tiposOperacao"
                    [tiposPadrao]="tiposPadrao"
                    [tiposPadraoIniciais]="tiposPadraoIniciais"
                    [emissores]="emissores"
                    [isEdicao]="isEditMode">
                </app-natureza-operacao-dados-gerais-tab>
            </mat-tab>

            <!-- ICMS ou Simples Nacional (condicional) -->
            @if (isSimples) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">auto_awesome</mat-icon>
                    <span class="tab-label-text">Simples Nacional</span>
                    @if (isAbaInvalida('icmsSn')) {
                    <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
                    }
                </ng-template>
                <app-natureza-operacao-icmssn-tab
                    [form]="form"
                    [csosns]="csosns"
                    [modalidadesBc]="modalidadesBc"
                    [modalidadesBcSt]="modalidadesBcSt"
                    [formulasIcmsSn]="formulasIcmsSn"
                    [estadosFormulas]="estadosFormulasIcmsSn"
                    [idNaturezaOperacao]="idNaturezaOperacao"
                    [excecoesPendentes]="_icmsSnExcecoesPendentes"
                    (excecoesChange)="onIcmsSnExcecoesChange($event)">
                </app-natureza-operacao-icmssn-tab>
            </mat-tab>
            }
            @if (mostrarIcms) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">receipt_long</mat-icon>
                    <span class="tab-label-text">ICMS</span>
                    @if (isAbaInvalida('icms')) {
                    <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
                    }
                </ng-template>
                <app-natureza-operacao-icms-tab
                    [form]="form"
                    [codigoTributos]="cstsIcms"
                    [modalidadesBc]="modalidadesBc"
                    [modalidadesBcSt]="modalidadesBcSt"
                    [motivosDesoneracaoIcms]="motivosDesoneracaoIcms"
                    [motivosReducaoAdRem]="motivosReducaoAdRem"
                    [formulasIcms]="formulasIcms"
                    [estadosFormulas]="estadosFormulasIcms"
                    [idNaturezaOperacao]="idNaturezaOperacao"
                    [excecoesPendentes]="_icmsExcecoesPendentes"
                    (excecoesChange)="onIcmsExcecoesChange($event)">
                </app-natureza-operacao-icms-tab>
            </mat-tab>
            }

            <!-- IPI -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">factory</mat-icon>
                    <span class="tab-label-text">IPI</span>
                    @if (isAbaInvalida('ipi')) {
                    <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
                    }
                </ng-template>
                <app-natureza-operacao-ipi-tab
                    [form]="form"
                    [codigoTributos]="cstsIpi"
                    [modalidadesBcSt]="modalidadesBcSt"
                    [formulasIpi]="formulasIpi"
                    [estadosFormulas]="estadosFormulasIpi"
                    [idNaturezaOperacao]="idNaturezaOperacao"
                    [excecoesPendentes]="_ipiExcecoesPendentes"
                    (excecoesChange)="onIpiExcecoesChange($event)">
                </app-natureza-operacao-ipi-tab>
            </mat-tab>

            <!-- PIS -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">percent</mat-icon>
                    <span class="tab-label-text">PIS</span>
                    @if (isAbaInvalida('pis')) {
                    <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
                    }
                </ng-template>
                <app-natureza-operacao-pis-tab
                    [form]="form"
                    [codigoTributos]="cstsPis"
                    [modalidadesBcSt]="modalidadesBcSt"
                    [formulasPis]="formulasPis"
                    [estadosFormulas]="estadosFormulasPis"
                    [idNaturezaOperacao]="idNaturezaOperacao"
                    [excecoesPendentes]="_pisExcecoesPendentes"
                    (excecoesChange)="onPisExcecoesChange($event)">
                </app-natureza-operacao-pis-tab>
            </mat-tab>

            <!-- COFINS -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">percent</mat-icon>
                    <span class="tab-label-text">COFINS</span>
                    @if (isAbaInvalida('cofins')) {
                    <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
                    }
                </ng-template>
                <app-natureza-operacao-cofins-tab
                    [form]="form"
                    [codigoTributos]="cstsCofins"
                    [modalidadesBcSt]="modalidadesBcSt"
                    [formulasCofins]="formulasCofins"
                    [estadosFormulas]="estadosFormulasCofins"
                    [idNaturezaOperacao]="idNaturezaOperacao"
                    [excecoesPendentes]="_cofinsExcecoesPendentes"
                    (excecoesChange)="onCofinsExcecoesChange($event)">
                </app-natureza-operacao-cofins-tab>
            </mat-tab>

            <!-- ISSQN -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">business_center</mat-icon>
                    <span class="tab-label-text">ISSQN</span>
                    @if (isAbaInvalida('issqn')) {
                    <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
                    }
                </ng-template>
                <app-natureza-operacao-issqn-tab
                    [form]="form"
                    [codigoTributos]="indicadoresIss"
                    [modalidadesBcSt]="modalidadesBcSt"
                    [indicadoresIncentivoFiscalIssqn]="indicadoresIncentivoFiscalIssqn"
                    [formulasIssqn]="formulasIssqn"
                    [estadosFormulas]="estadosFormulasIssqn"
                    [idNaturezaOperacao]="idNaturezaOperacao"
                    [excecoesPendentes]="_issqnExcecoesPendentes"
                    (excecoesChange)="onIssqnExcecoesChange($event)">
                </app-natureza-operacao-issqn-tab>
            </mat-tab>

            <!-- Importação (apenas se tipo = Entrada) -->
            @if (mostrarIi) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">flight_takeoff</mat-icon>
                    <span class="tab-label-text">Importação</span>
                    @if (isAbaInvalida('ii')) {
                    <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
                    }
                </ng-template>
                <app-natureza-operacao-ii-tab
                    [form]="form"
                    [formulasIi]="formulasIi"
                    [estadosFormulas]="estadosFormulasIi"
                    [idNaturezaOperacao]="idNaturezaOperacao"
                    [excecoesPendentes]="_iiExcecoesPendentes"
                    (excecoesChange)="onIiExcecoesChange($event)">
                </app-natureza-operacao-ii-tab>
            </mat-tab>
            }

            <!-- Reforma Tributária (só operação de saída) -->
            @if (mostrarReforma) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">hub</mat-icon>
                    <span class="tab-label-text">Reforma Tributária</span>
                    @if (isAbaInvalida('reformaTributaria')) {
                    <mat-icon class="tab-status-icon tab-status-vermelho">error_outline</mat-icon>
                    }
                </ng-template>
                <app-natureza-operacao-reforma-tributaria-tab
                    [form]="form">
                </app-natureza-operacao-reforma-tributaria-tab>
            </mat-tab>
            }

            <!-- Totais -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="material-symbols-outlined tab-icon">functions</mat-icon>
                    <span class="tab-label-text">Totais</span>
                </ng-template>
                <app-natureza-operacao-totais-tab
                    [form]="form"
                    [tiposBaseCalculoRetencao]="tiposBaseCalculoRetencao"
                    [indicadoresComposicaoTotalItem]="indicadoresComposicaoTotalItem"
                    [indicadoresDeducaoDesoneracaoIcms]="indicadoresDeducaoDesoneracaoIcms"
                    [indicadoresComposicaoTotalPisSt]="indicadoresComposicaoTotalPisSt"
                    [indicadoresComposicaoTotalCofinsSt]="indicadoresComposicaoTotalCofinsSt"
                    [tiposOperacaoVeiculo]="tiposOperacaoVeiculo"
                    [regimesEspeciaisTributacaoIssqn]="regimesEspeciaisTributacaoIssqn"
                    [formulasTotais]="formulasTotais"
                    [estadosFormulas]="estadosFormulasTotais">
                </app-natureza-operacao-totais-tab>
            </mat-tab>

        </mat-tab-group>

        }

    </div>
</div>

<app-footer-action
    salvarLabel="Salvar"
    [isLoadingSalvar]="isSaving"
    [isSalvarDisabled]="isLoading"
    (cancelar)="cancelar()"
    (salvar)="salvar()">
</app-footer-action>
